import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import moment from "moment";
import videojs from "video.js";
// import "video.js/dist/video-js.css";
// import videojs from "video.js";
// import "video.js/dist/video-js.css";
// import 'video.js/dist/video.min.js';
import VideoPlayer from '@/components/VideoPlayer.vue';
// import { VideoPlayer } from '@videojs-player/vue'
// import Player from "@vimeo/player";
import config from '@/assets/js/config.js';
import ContentConfirmModal from '../../components/upload/ContentConfirmModal.vue';

const convertNumberService = new ConvertNumService();

export default {
    name: "contentList",
    // props: {
    //     options: {
    //     type: Object,
    //     default() {
    //         return {};
    //     }
    //     }
    // },
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
        VideoPlayer,
        // Player,
        ContentConfirmModal,
    },

    data() {
        return {
            id:null,
            courseId:null,
            lastPage: "",
            currentPage: "",
            contentInfo: {},
            contentGroupInfo: {},
            group_id: 0,
            course_id: this.$route.params.courseId,
            server_url_access: process.env.VUE_APP_SERVER,
            url_token: this.$store.state.user['token'],
            videojs,
            isModalVisible: false,
            videoOptions: {
                autoplay: true,
                controls: true,
                sources: [
                {
                    // src: 'https://bitdash-a.akamaihd.net/content/MI201109210084_1/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.m3u8',
                    src: 'http://localhost/kyaung-app/backend/public/api/v2/my/course/4827/content-gp/2/content/22/stream/.m3u8',                    
                    type: "application/x-mpegurl"
                }
                ]
            },
            videoOpt: null,
            // player: null
            isLoading: false,
            processIdList: [],
            checkInterval: null,
            currentPagePagination: 1,
            config,
            dialog1: {
                title: "အတည်ပြုချက်",
                text: "ဤသင်တန်းအတွက်သာ ဖျက်လိုပါသလား ဒါမှမဟုတ် အားလုံးကနေ အပြီးသတ် ဖျက်လိုပါသလား။",
                buttons: [
                    { label: "ဤသင်တန်းသာ ဖျက်မည်", handler: this.deleteForOne},
                    { label: "အားလုံးမှ ဖျက်မည်", handler: this.deleteForAll }
                ]},
            dialog2: {
                title: '',
                text: '',
                buttons: [
                    { label: "သေချာပါသည်", handler: this.dialog2Confirm },
                    { label: "မသေချာပါ", handler: () => this.$modal.hide("dialog2") }
                ],
                payload: null,
                isDeleteAll: null,
                type: null,
            }
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
        // player () {
        //     return this.$refs.videoPlayer.player
        // }
    },

    methods: { 
        getContentGroup() {
            axios.get("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id)
                .then((response) => {
                    this.contentGroupInfo = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                });
        },
        async showVideoContent(contentId) {
            try {
                this.$router.push({
                    name: "videoStreaming",
                    params: { 
                        course_class_id: this.course_id,
                        group_id: this.group_id,
                        id: contentId
                    }
                });
                // document.getElementById('div_video').innerHTML = '<video lass="video-js" id="my_video_1" controls preload="auto" data-setup="{}" style="height: 600px; width: 800px;" />';
                // var player = videojs('my_video_1');                                  
                // player.src({ type: "application/x-mpegurl", src: src });
                // player.muted(true);
                // player.load();
                // player.play();
                // document.getElementById('div_video').innerHTML = '<video class="video-js" id="my_video_1" controls  style="height: 600px; width: 800px;"><source src=""></video>';
                // var player = videojs('my_video_1', {
                //     sources: {
                //         autoplay: true,
                //         controls: true,
                //         type: "application/x-mpegurl", 
                //         src: src
                //     }
                // },
                //  () => {
                //     // player.pause();
                //     // player.load();
                //     player.muted(true);
                //     player.play();
                //     player.muted(false);
                //     // this.player.log('onPlayerReady', this);
                //     // this.player.muted(true);
                //     // this.player.load();
                //     // this.player.play();                  
                // }
                // );  
                
                // const videoContainer = document.getElementById("my_video_1");
                // this.player = new Player(videoContainer);

                // this.player.setMuted(true);
                // this.player.setVolume(0);
                // this.player.play();           
                // player.ready(function(){
                //     player.muted(true);
                //     player.load();
                //     player.play();
                // });
            } catch (error) {
                console.error('Error fetching video:', error);
            }
        },
        
        async showPDFContent(contentId) {
            try {
                // this.$router.push({
                //     name: "pdfViewer",
                //     params: { 
                //         course_id: this.course_id,
                //         group_id: this.group_id,
                //         id: contentId
                //     }
                // });

                const routeData = this.$router.resolve({
                    name: "pdfViewer",
                    params: {
                    course_id: this.course_id,
                    group_id: this.group_id,
                    id: contentId
                }});
                window.open(routeData.href, '_blank');
            } catch (error) {
                console.error('Error fetching video:', error);
            }
        },

        async showImageContent(contentId) {
            try {
                this.$router.push({
                    name: "imageStreaming",
                    params: { 
                        course_class_id: this.course_id,
                        group_id: this.group_id,
                        id: contentId
                    }
                });
            } catch (error) {
                console.error('Error fetching image:', error);
            }
        },

        close() {
            this.isModalVisible = false;
            this.$emit("close");
        },

        getContentList(page = 1) {
            this.currentPagePagination =  page;  
            axios.get("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/list?page=" + page)
                .then((response) => {
                    this.contentInfo = response.data;
                    if (this.contentInfo.data.length == 0 && page > 1) {
                        this.getContentList(1);
                    }
                    this.contentInfo.total = convertNumberService.convertEng2Mm(this.contentInfo.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.contentInfo.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.contentInfo.current_page);
                    this.processIdList = this.contentInfo.data.filter(item => item.is_processing == true).map(item => item.id);
                    this.checkFilesCompleteOrNot();
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });                        
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        downloadFile(content_id, filename) {
            axios.get("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/" + content_id + "/download", {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            responseType: 'blob' // responseType is a sibling of headers, not a child
            })
            .then(response => {
            this.getContentList();
            if (response.status == 200) {
                const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf;base64' }));
                const tempLink = document.createElement('a');
                tempLink.style.display = 'none';
                tempLink.href = fileURL;
                tempLink.setAttribute('download', filename);
                setTimeout(function () {
                    var prntWin = window.open();
                    prntWin.document.write("<html><head><title>" + filename + "</title></head><body>"
                        + '<embed width="100%" height="100%" name="plugin" src="' + tempLink + '" '
                        + 'type="application/pdf" internalinstanceid="21"></body></html>');
                    prntWin.document.close();
                }, 1000);           
            }
            })
            .catch(error => {
                if (error.response.status == 404) {
                    this.$router.push({
                        name: 'notFound'
                    });
                }
                if (error.response.status == 403) {
                    this.$router.push({
                        name: 'forbidden'
                    });                        
                }
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('/');
                }
                this.getContentList();
                if(error) {
                    this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                }                
            })
        }, 
        
        contentDelete(contentId) {
            const currentPagePagination = this.currentPagePagination;
            axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/" + contentId + "/delete", { params: { is_delete_all: this.dialog2.isDeleteAll ? 1 : 0 } })
                .then((response) => {
                    this.getContentList(currentPagePagination);
                    if (response.data.status == 200) {
                        this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } if (response.data.status == 404) {
                        this.$notification.success("Content Not Found.", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } if (response.data.status == 400) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.getContentList(currentPagePagination);
                    if (error) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                });
        },

        enablePC(contentId) {
            this.isLoading = true;
            axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/" + contentId + "/enableDesktop")
                .then((response) => {
                    this.getContentList(convertNumberService.convertMm2Eng(this.currentPage));
                    if (response.data.status == 200) {
                        this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.isLoading = false;
                    } if (response.data.status == 404) {
                        this.$notification.success("File No Exist Yet!.", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.isLoading = false;
                    } if (response.data.status == 400) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.isLoading = false;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                        this.isLoading = false;
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                        this.isLoading = false;
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.getContentList();
                    if (error) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.isLoading = false;
                    }
                });
        },

        disablePC(contentId) {
            this.isLoading = true;
            axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/" + contentId + "/disableDesktop")
                .then((response) => {
                    this.getContentList(convertNumberService.convertMm2Eng(this.currentPage));
                    if (response.data.status == 200) {
                        this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.isLoading = false;
                    } if (response.data.status == 404) {
                        this.$notification.success("File No Exist Yet!.", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.isLoading = false;
                    } if (response.data.status == 400) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.isLoading = false;
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                        this.isLoading = false;
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                        this.isLoading = false;
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.getContentList();
                    if (error) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.isLoading = false;
                    }
                });
        },

        checkFilesCompleteOrNot() {
            if (this.checkInterval) {
                clearInterval(this.checkInterval);
            }
            const checkStatus = async () => {
                if (this.$route.name != 'contentList' || this.processIdList.length == 0){
                    clearInterval(this.checkInterval);
                    return;
                }
                axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/is-processing", { process_id_list: this.processIdList })
                .then((response) => {
                    const inProgressProcessIds = response.data.process_contents_id;
                    if (JSON.stringify(inProgressProcessIds) !== JSON.stringify(this.processIdList)) {
                        this.getContentList(convertNumberService.convertMm2Eng(this.currentPage));
                    }
                })
                .catch((error) => {
                    console.error('Error checking file completion:', error);
                    clearInterval(this.checkInterval);
                });
            };
            this.checkInterval = setInterval(checkStatus, 20000);
          },
          goToContentGroup() {
            this.$router.push({ name: 'contentGroup', params: {id: this.courseId } });
        },

        deleteFailedContent(contentId) {
            axios.post("my/course/" + this.$route.params.courseId + "/content-gp/" + this.$route.params.id + "/content/" + contentId + "/deleteFailedContent")
                .then((response) => {
                    this.getContentList();
                    if (response.data.status == 200) {
                        this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } if (response.data.status == 404) {
                        this.$notification.success("File No Exist Yet!.", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.getContentList();
                    if (error) {
                        this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                });
        },

        confirmSuccessDelete(contentId) {
            this.dialog1.payload = contentId;
            this.dialog2.type = 'success'
            this.$modal.show('dialog1');
        },

        confirmFailedDelete(contentId) {
            this.dialog2.title = "သတိပေးချက်";
            this.dialog2.text = "ဖျက်လိုသည်မှာ သေချာပါသလား။";
            this.dialog2.payload = contentId;
            this.dialog2.type = 'failed'
            this.$modal.show('dialog2');
        },

        deleteForAll() {
            this.setDialog2("သတိပေးချက်", "သင်တန်းအားလုံးအတွက် ဖျက်လိုသည်မှာ သေချာပါသလား။", true)
        },

        deleteForOne() {
            this.setDialog2("သတိပေးချက်", "ဖျက်လိုသည်မှာ သေချာပါသလား။", false)
        },

        setDialog2(title, text, isDeleteAll) {
            this.dialog2.title = title;
            this.dialog2.text = text;
            this.dialog2.isDeleteAll = isDeleteAll;
            this.dialog2.payload = this.dialog1.payload;
            this.$modal.hide('dialog1');
            this.$modal.show('dialog2');
        },

        dialog2Confirm() {
            const id = this.dialog2.payload;
            const type = this.dialog2.type;
            if (type === "failed") {
                this.deleteFailedContent(id);
            } else {
                this.contentDelete(id);
            }
            this.$modal.hide('dialog1');
            this.$modal.hide('dialog2');
        }
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        /*
        ** Start
        ** request header for streaming
        **
        */
        videojs.Vhs.xhr.beforeRequest = (options) => {
            if (!options.headers){
                options.headers = {}
            }
            options.headers["Authorization"] = `Bearer ${this.$store.state.user['token']}`;
        }
        /*
        ** End
        */
        this.id = this.$route.params.id;
        this.courseId = this.$route.params.courseId;
        this.group_id = this.$route.params.id;  
        this.getContentGroup();
        this.getContentList();
    }
   
};
